import { FrequenceEnum } from '../../constants/frequence.config';

export class FrequenceHelper {
  static getNumberOfPeriods(codeFrequence: string | FrequenceEnum) {
    switch (codeFrequence) {
      case 'HEBDO':
      case 'HEBDOMADAIRE':
        return 52;
      case 'BIHEBDO':
      case 'AUX_DEUX_SEMAINES':
        return 26;
      case 'BIMENSUEL':
        return 24;
      case 'MENSUEL':
        return 12;
      case 'AUX_DEUX_MOIS':
        return 6;
      case 'TRIMESTRIEL':
        return 4;
      case 'SEMESTRIEL':
        return 2;
      case 'ANNUEL':
        return 1;
      default:
        return 0;
    }
  }

  static getTotalPerYear(montant: number, frequence: string): number {
    return montant * FrequenceHelper.getNumberOfPeriods(frequence);
  }

  static getTotalPerPeriod(entries: Array<{ montant: number; frequence: string }>, frequenceFinale: FrequenceEnum) {
    const totalPerYear = entries.reduce(
      (total, { montant, frequence }) => total + FrequenceHelper.getTotalPerYear(montant, frequence),
      0
    );

    return totalPerYear / this.getNumberOfPeriods(frequenceFinale);
  }
}
